module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Niederrohrdorf_AG-bab072c9878b19c8e50100a7ac3a4314.svg";